<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Chapter-Title-Page-Break" id="_idParaDest-3">Author’s Note</p>
<p class="ORIM-Chapter-Opener-Paragraph">A couple of things before you start.</p>
<p class="ORIM-Body-Text">First, the technology. This novel was written in 1995 when cellular phones were the exception rather than the rule. People on the street still called from public booths and kiosks. Also, the GPS device used by Snake was state of the art then. No Magellans, no Garmins, no GPS apps for your smartphone. In 1995 it took a special plug-in device plus a PC to make use of GPS technology.</p>
<p class="ORIM-Body-Text">But the novel is not about technology. The issues it addresses—the so-called War on Drugs and all the misery and corruption it causes—are as real as ever. People are coming around (as of this writing, Colorado and Washington have legalized marijuana) but we’ve still got a long way to go before we stop filling our jails with fellow Americans whose only crime was wanting to get high.</p>
<p class="ORIM-Body-Text">So approach the novel as you would a movie from the mid-nineties. Don’t expect characters to whip out a cellphone and call any other character they wish whenever they wish.</p>
<p class="ORIM-Body-Text">And speaking of characters, this started out as John VanDuyne’s novel. But as the writing progressed, Poppy kept waving from the page and saying, <span class="Italic">Hey, this is really </span>my<span class="Italic"> story, you know. I’m the one with the most dramatic arc</span>. I ignored her until maybe the halfway point when I realized she was right. So I let her have the story. When I finished, I went back and let her do her thing in the first half. The result was one of my most popular characters ever—next to Repairman Jack.</p>
<p class="ORIM-Body-Text-Line-Break ParaOverride-1">F. Paul Wilson</p>
<p class="ORIM-Body-Text ParaOverride-1">The Jersey Shore</p>
<p class="ORIM-Body-Text ParaOverride-2">2014</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DeepAsTheMarrow3.vue?3a017100